import React, { Component } from 'react';

import SiteLogo from '../pages/images/thumbs/logo.png';

import Vkontakte from '../pages/images/svg/vk.svg';
import Telegram from '../pages/images/svg/telegram.svg';
import GitHub from '../pages/images/svg/github.svg';

class Footer extends Component {
    render(){
        return (
            <footer>
            <h1><img src={SiteLogo} width="66" title="Ufon" alt="Ufon" /></h1>

            <div className="social" >
                <a href="https://www.vk.com/ufonium" ><img src={Vkontakte} width="20" alt="vkontakte" /> </a>
                <a href="tg://resolve?domain=ufona" ><img src={Telegram} width="20" alt="telegram" /> </a>
                <a href="https://www.github.com/ufon" ><img src={GitHub} width="20" alt="github" /> </a>
            </div>

            <p className="copyright" >© 2017 ufon.brest.by</p>

            </footer>
        );
    }
}

export default Footer


// WEBPACK FOOTER //
// ./src/layouts/Footer.js